import type { opensearchtypes } from '@opensearch-project/opensearch';
import { IBuildSearchPayload } from '@logz-pkg/opensearch-dsl';
import { cloneDeep } from 'lodash';

const baseSearchPayload: { params: opensearchtypes.SearchRequest } = {
  params: {
    index: 'logzioCustomerIndex*',
    body: {
      track_total_hits: true,
      version: true,
      // for filtering specific accounts u can use that array
      // e.g. _source: { excludes: ['logzioAccountId-9', 'logzioAccountId-10'] },
      // will filter search only accounts 9 and 10
      _source: { excludes: [] },
      size: 500,
      sort: [{ '@timestamp': { order: 'desc' } }],
      stored_fields: ['*'],
      docvalue_fields: [{ field: '@timestamp', format: 'date_time' }],
    },
  },
};

const buildSearchPayload = ({
  from = 0,
  query = {},
  size = 500,
  aggs = {},
  source = {},
  sort = [{ '@timestamp': { order: 'desc' } }],
  searchAfter,
  timeout,
  terminateAfter,
  trackTotalHits = true,
  highlight,
  storedFields,
}: IBuildSearchPayload): { params: opensearchtypes.SearchRequest } => {
  const payload = cloneDeep(baseSearchPayload);

  if (!payload.params.body) return payload;

  payload.params.body.from = from;
  payload.params.body.query = query;
  payload.params.body.size = size;
  payload.params.body.aggs = aggs;
  payload.params.body.sort = sort;
  payload.params.body._source = source;
  payload.params.body.track_total_hits = trackTotalHits;
  payload.params.body.highlight = highlight;
  payload.params.body.stored_fields = storedFields;

  if (timeout) {
    payload.params.body.timeout = timeout;
  }

  if (terminateAfter) {
    payload.params.body.terminate_after = terminateAfter;
  }

  if (searchAfter) {
    payload.params.body.search_after = searchAfter;
  }

  return payload;
};

export const opensearchQueryService = { buildSearchPayload };
